import { LoadingState, LoadingStates, Poi } from '../poi';
import { types } from 'mobx-state-tree';
import { fetchFavouriteList } from './flows/fetch-favourite-list';
import { addFavourite } from './flows/add-favourite';
import { removeFavourite } from './flows/revove-favourite';

export const FavouriteStore = types
  .model({
    status: types.optional(LoadingState, LoadingStates.init),
    list: types.optional(types.array(Poi), []),
    selected: types.optional(types.array(Poi), []),
    selectable: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    fetch: (...args) => fetchFavouriteList(self, ...args),
    add: (...args) => addFavourite(self, ...args),
    remove: (...args) => removeFavourite(self, ...args),
    select: (poi) => {
      if (
        self.selected.filter((selected) => selected.id === poi.id).length === 0
      )
        self.selected = self.selected.concat(JSON.parse(JSON.stringify(poi)));
    },
    deselect: (poi) =>
      (self.selected = self.selected.filter(
        (selected) => selected.id !== poi.id,
      )),
    deselectAll: (...args) => {
      self.selected = [];
    },
    setSelectable: (selectable) => {
      self.selectable = selectable;
    },
  }));

export const initialState = {
  list: [
    {
      address: {
        city: 'Harlowton',
        country: '',
        zipCode: '59036',
        street: 'Central Avenue South',
        number: '106',
      },
      en: {
        title: 'Graves Hotel',
        description:
          "The Graves Hotel is a historic hotel located at 106 South Central Avenue in Harlowton, Montana. A. C. Graves, a leading figure in Harlowton's early development, had the hotel built in 1909; it was one of the first businesses to be built after a fire destroyed much of downtown Harlowton in 1907. The hotel was the first sandstone building in Harlowton, though the stone eventually became a common building material; its design features a projecting corner oriel window topped by a metal cupola. In addition to hosting visitors and railroad travelers, the hotel also served as a community meeting place and business center.The hotel was added to the National Register of Historic Places on August 6, 1980.",
        openingHours: null,
      },
      de: {
        title: 'Graves Hotel',
        description:
          "The Graves Hotel is a historic hotel located at 106 South Central Avenue in Harlowton, Montana. A. C. Graves, a leading figure in Harlowton's early development, had the hotel built in 1909; it was one of the first businesses to be built after a fire destroyed much of downtown Harlowton in 1907. The hotel was the first sandstone building in Harlowton, though the stone eventually became a common building material; its design features a projecting corner oriel window topped by a metal cupola. In addition to hosting visitors and railroad travelers, the hotel also served as a community meeting place and business center.The hotel was added to the National Register of Historic Places on August 6, 1980.",
        openingHours: null,
      },
      fr: {
        title: 'Graves Hotel',
        description:
          "The Graves Hotel is a historic hotel located at 106 South Central Avenue in Harlowton, Montana. A. C. Graves, a leading figure in Harlowton's early development, had the hotel built in 1909; it was one of the first businesses to be built after a fire destroyed much of downtown Harlowton in 1907. The hotel was the first sandstone building in Harlowton, though the stone eventually became a common building material; its design features a projecting corner oriel window topped by a metal cupola. In addition to hosting visitors and railroad travelers, the hotel also served as a community meeting place and business center.The hotel was added to the National Register of Historic Places on August 6, 1980.",
        openingHours: null,
      },
      nl: {
        title: 'Graves Hotel',
        description:
          "The Graves Hotel is a historic hotel located at 106 South Central Avenue in Harlowton, Montana. A. C. Graves, a leading figure in Harlowton's early development, had the hotel built in 1909; it was one of the first businesses to be built after a fire destroyed much of downtown Harlowton in 1907. The hotel was the first sandstone building in Harlowton, though the stone eventually became a common building material; its design features a projecting corner oriel window topped by a metal cupola. In addition to hosting visitors and railroad travelers, the hotel also served as a community meeting place and business center.The hotel was added to the National Register of Historic Places on August 6, 1980.",
        openingHours: null,
      },
      _id: '6266b1ed6de2f1eae9988a26',
      id: 'sygic-poi:17695703',
      categories: [
        {
          name: 'eatdrink',
          color: '#FF7400',
          active: true,
          selected: true,
          _id: '62442cf9269e8eed7f88e871',
          __v: 0,
        },
      ],
      eMail: null,
      images: [],
      localRating: 0.0260096153846155,
      location: {
        type: 'Point',
        coordinates: [-109.8313231, 46.4343933],
      },
      phone: null,
      provider: 'sygic',
      rating: 3,
      sunnyRating: 10,
      url: 'http://www.graveshotel.org/',
      copyright: {
        source: 'Sygic Maps',
        sourceUrl: 'https://www.sygic.com/',
        _id: '62b1ec37a4be76a4e62c6d4e',
      },
    },
  ],
};
